import { Component } from '@angular/core';

@Component({
  selector: 'app-kno2-service-search',
  templateUrl: './kno2-service-search.component.html',
  styleUrls: ['./kno2-service-search.component.scss']
})
export class Kno2ServiceSearchComponent
{

}
